import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, Fragment as _Fragment, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString } from "vue"

const _hoisted_1 = { class: "page-system-header" }
const _hoisted_2 = /*#__PURE__*/_createTextVNode("退出预览")
const _hoisted_3 = /*#__PURE__*/_createTextVNode("预览")
const _hoisted_4 = /*#__PURE__*/_createTextVNode("保存")
const _hoisted_5 = /*#__PURE__*/_createTextVNode("退出编辑")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_button = _resolveComponent("el-button")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", null, [
      (_ctx.headerConfig.preview)
        ? (_openBlock(), _createBlock(_component_el_button, {
            key: 0,
            size: "medium",
            onClick: _ctx.exitPreview
          }, {
            default: _withCtx(() => [
              _hoisted_2
            ]),
            _: 1
          }, 8, ["onClick"]))
        : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
            _createVNode(_component_el_button, {
              type: "primary",
              plain: "",
              size: "medium",
              onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.headerBut('preview')))
            }, {
              default: _withCtx(() => [
                _hoisted_3
              ]),
              _: 1
            }),
            _createVNode(_component_el_button, {
              type: "primary",
              size: "medium",
              onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.headerBut('submit')))
            }, {
              default: _withCtx(() => [
                _hoisted_4
              ]),
              _: 1
            })
          ], 64))
    ]),
    _createElementVNode("h6", null, _toDisplayString(_ctx.headerConfig.preview ? '正在预览中':'正在编辑中'), 1),
    _createVNode(_component_el_button, {
      size: "medium",
      onClick: _ctx.exitEdit
    }, {
      default: _withCtx(() => [
        _hoisted_5
      ]),
      _: 1
    }, 8, ["onClick"])
  ]))
}